import { signup_model } from "./model"


export const fetchSignupCompCreateData = (state) => state.signupCompCreate.ByType
export const fetchedSignupCreateDataByEmail = (state) => state.signupCompCreate.ByProfit.byEmailData?.data
export const fetchedSignupCreateData = (state) => state.signupCompCreate.ByProfit.byEmailData
export const sentOTP = (state) => state.signupCompCreate.ByProfit.otpSent
export const isSaving = (state) => state.signupCompCreate.ByType.isSaving
export const finalstepcomplete = (state) => state.signupCompCreate.ByType.finalstepcomplete
export const isotpFetching = (state) => state.signupCompCreate.ByType.otpFetching
export const pwValidating = (state) => state.signupCompCreate.ByType.pwValidating
export const getvalidatedPW = (state) => state.signupCompCreate.ByProfit.validatedpw
export const getvalidatedOTP = (state) => state.signupCompCreate.ByProfit.validatedotp
export const getisDataAlreadySavedChkObj = (state) => state.signupCompCreate.ByProfit.isDataAlreadySavedChkObj
export const getfinalDomainCreationDataObj = (state) => state.signupCompCreate.ByProfit.finalDomainCreationDataObj
export const getLoginObject = (state, props) => {
    if(state.signupCompCreate.ByProfit.byEmailData?.data){
        return state.signupCompCreate.ByProfit.byEmailData?.data?.data
    }else{
        return signup_model();
    }
}
